import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ContributorsWithCompaniesWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContributorsWithCompaniesCompanyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ContributorsWithCompaniesCompanyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > :not(:last-child) {
    margin-right: -9px;
  }
`;

export const ContributorsWithCompaniesInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ContributorsWithCompaniesNames = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;

export const ContributorsWithCompaniesNamesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 11px;
`;

export const ContributorsWithCompaniesDate = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const ContributorsWithCompaniesPeople = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);

  & .comma-separator,
  & .and-separator {
    font-weight: 700;
    color: var(--color-data-community-foreground);
  }
`;

export const ContributorsWithCompaniesPeopleHighlight = styled(ContributorsWithCompaniesPeople)<{
  disabled: boolean;
}>`
  font-weight: 700;
  color: ${({ disabled }) =>
    !disabled ? `var(--color-data-community-foreground)` : `rgba(162, 101, 101, 0.60)`};

  cursor: pointer;
`;
